import { applyColor }from '~src/style/ColorService';
import React = require('react');
import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';

import { VPC_BOLD_FONT_WEIGHT } from '~src/settings/styles/CommonStyles';

export const sectionHeader = style({
  fontSize: TabStyles.Typography.Sizing.XLarge,
  fontWeight: VPC_BOLD_FONT_WEIGHT,
  paddingBottom: TabStyles.Spacing.MediumSpace,
  color: applyColor(DesignTokens.color.font.default.default, TabStyles.Typography.Color.PrimaryDark)
});

export const sectionDescription = style({
  paddingBottom: TabStyles.Spacing.DefaultSpace,
});

export const settingSection = style({
  paddingTop: TabStyles.Spacing.MediumSpace,
});
